export default __webpack_public_path__ + "static/media/deleteUpload.cfceef28.svg";